module.exports = __webpack_public_path__ + "static/media/envelope-open-text.223d6fd7.svg";